import { render, staticRenderFns } from "./ContatoCard.vue?vue&type=template&id=79f23136&scoped=true&"
import script from "./ContatoCard.vue?vue&type=script&lang=js&"
export * from "./ContatoCard.vue?vue&type=script&lang=js&"
import style0 from "./ContatoCard.vue?vue&type=style&index=0&id=79f23136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f23136",
  null
  
)

export default component.exports